module.exports = __webpack_public_path__ + "static/media/boothLandscape.112c4662.jpg";